// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-NativeScrollbar-module--cls1--3Bh4S","cls2":"styles-NativeScrollbar-module--cls2--1-2TP styles-NativeScrollbar-module--cls1--3Bh4S"};